import { render } from "./WeatherLocation.vue?vue&type=template&id=2954966c&ts=true"
import script from "./WeatherLocation.vue?vue&type=script&lang=ts"
export * from "./WeatherLocation.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/weather-widget-vue/weather-widget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__